/* Accessibility fixes (WCAG 2.2 AA). Loaded from layout/theme.liquid. */
(function () {
  if (window.__a11yFixes) return;
  window.__a11yFixes = true;

  var STORE_KEY = 'zenimal-motion-paused';
  var PAUSE_ICON = '<svg viewBox="0 0 16 16" aria-hidden="true" focusable="false"><rect x="3" y="2" width="3.5" height="12"/><rect x="9.5" y="2" width="3.5" height="12"/></svg>';
  var PLAY_ICON = '<svg viewBox="0 0 16 16" aria-hidden="true" focusable="false"><path d="M4 2l10 6-10 6z"/></svg>';

  function readPref() {
    try {
      var v = window.localStorage.getItem(STORE_KEY);
      if (v === '1') return true;
      if (v === '0') return false;
    } catch (e) {}
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }
  function savePref(paused) {
    try { window.localStorage.setItem(STORE_KEY, paused ? '1' : '0'); } catch (e) {}
  }

  var motionPaused = readPref();

  /* Images used as fallback content inside <video> are decorative (1.1.1) */
  function fixVideoFallbackImages(root) {
    (root || document).querySelectorAll('video > img:not([alt])').forEach(function (img) {
      img.setAttribute('alt', '');
    });
  }

  /* Scrollable areas must be reachable with the keyboard (2.1.1) */
  var FOCUSABLE = 'a[href], button, input, select, textarea, [tabindex]:not([tabindex="-1"]), audio[controls], video[controls], summary';
  function fixScrollableRegions() {
    document.querySelectorAll('body *').forEach(function (el) {
      if (el.hasAttribute('tabindex') || el.closest('[aria-hidden="true"]')) return;
      var cs = window.getComputedStyle(el);
      var scrollX = (cs.overflowX === 'auto' || cs.overflowX === 'scroll') && el.scrollWidth > el.clientWidth + 1;
      var scrollY = (cs.overflowY === 'auto' || cs.overflowY === 'scroll') && el.scrollHeight > el.clientHeight + 1;
      if (!scrollX && !scrollY) return;
      if (el.querySelector(FOCUSABLE)) return;
      el.setAttribute('tabindex', '0');
      if (!el.hasAttribute('role')) el.setAttribute('role', 'region');
      if (!el.hasAttribute('aria-label') && !el.hasAttribute('aria-labelledby')) {
        var heading = null;
        var node = el;
        while (node && node !== document.body && !heading) {
          heading = node.querySelector('h2, h3');
          node = node.parentElement;
        }
        var label = heading ? heading.textContent.replace(/\s+/g, ' ').trim() : '';
        el.setAttribute('aria-label', (label ? label + ', ' : '') + 'scrollable');
      }
    });
  }

  /* Bring keyboard focus into view when it lands on an item scrolled out of sight (2.4.11) */
  document.addEventListener('focusin', function (event) {
    var el = event.target;
    if (!el || !el.getBoundingClientRect) return;
    var r = el.getBoundingClientRect();
    if (r.right <= 0 || r.left >= window.innerWidth) {
      try { el.scrollIntoView({ block: 'nearest', inline: 'nearest' }); } catch (e) {}
    }
  });

  /* Autoplaying, looping videos without controls get a pause button (2.2.2) */
  function setVideoButton(btn, playing) {
    btn.innerHTML = playing ? PAUSE_ICON : PLAY_ICON;
    btn.setAttribute('aria-label', playing ? 'Pause video' : 'Play video');
  }
  function addVideoButtons(root) {
    (root || document).querySelectorAll('video').forEach(function (video) {
      if (video.dataset.a11yToggle || video.controls) return;
      var autoplay = video.autoplay || video.hasAttribute('autoplay');
      if (!autoplay || !video.loop) return;
      var parent = video.parentElement;
      if (!parent) return;
      video.dataset.a11yToggle = '1';
      if (window.getComputedStyle(parent).position === 'static') parent.style.position = 'relative';
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'a11y-video-toggle';
      btn.dataset.userPaused = '';
      setVideoButton(btn, !video.paused);
      btn.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        if (video.paused) {
          btn.dataset.userPaused = '';
          var p = video.play();
          if (p && p.catch) p.catch(function () {});
        } else {
          btn.dataset.userPaused = '1';
          video.pause();
        }
      });
      video.addEventListener('play', function () { setVideoButton(btn, true); });
      video.addEventListener('pause', function () { setVideoButton(btn, false); });
      parent.appendChild(btn);
      if (motionPaused) video.pause();
    });
  }

  /* Site-wide control to pause all moving content (2.2.2) */
  var toggles = [];
  var sweepTimer = null;
  function sweepAnimations() {
    if (!document.getAnimations) return;
    document.getAnimations().forEach(function (a) {
      var timing = a.effect && a.effect.getTiming && a.effect.getTiming();
      if (!timing || timing.iterations !== Infinity) return;
      if (motionPaused) { if (a.playState === 'running') a.pause(); }
      else if (a.playState === 'paused') a.play();
    });
  }
  function applyMotion() {
    document.documentElement.classList.toggle('a11y-motion-paused', motionPaused);
    toggles.forEach(function (t) {
      t.textContent = motionPaused ? 'Play animations' : 'Pause animations';
      t.setAttribute('aria-pressed', motionPaused ? 'true' : 'false');
    });
    document.querySelectorAll('video[data-a11y-toggle]').forEach(function (v) {
      if (motionPaused) v.pause();
      else if (v.paused) {
        var btn = v.parentElement && v.parentElement.querySelector('.a11y-video-toggle');
        if (!btn || !btn.dataset.userPaused) {
          var p = v.play();
          if (p && p.catch) p.catch(function () {});
        }
      }
    });
    sweepAnimations();
    if (sweepTimer) { clearInterval(sweepTimer); sweepTimer = null; }
    if (motionPaused) sweepTimer = setInterval(sweepAnimations, 2000);
  }
  function makeToggle(extraClass) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'a11y-motion-toggle ' + extraClass;
    b.addEventListener('click', function () {
      motionPaused = !motionPaused;
      savePref(motionPaused);
      applyMotion();
    });
    toggles.push(b);
    return b;
  }
  function addMotionToggles() {
    var skipBtn = makeToggle('a11y-motion-toggle--skip');
    var skipLink = document.querySelector('.skip-to-content-link');
    if (skipLink && skipLink.parentNode) skipLink.parentNode.insertBefore(skipBtn, skipLink.nextSibling);
    else document.body.insertBefore(skipBtn, document.body.firstChild);

    var footer = document.querySelector('footer, [role="contentinfo"]');
    if (footer) {
      var wrap = document.createElement('div');
      wrap.className = 'a11y-motion-footer';
      wrap.appendChild(makeToggle(''));
      footer.appendChild(wrap);
    }
  }

  /* Third-party popups (e.g. the Klaviyo signup form): give the dialog a real name,
     and return keyboard focus to where the person was when it closes (4.1.2, 2.4.3) */
  var lastOutsideFocus = null;
  var openDialogs = [];
  document.addEventListener('focusin', function (event) {
    var t = event.target;
    if (t && t.closest && !t.closest('[role="dialog"][aria-modal="true"]')) lastOutsideFocus = t;
  });
  function isShown(el) {
    if (!el.isConnected) return false;
    var r = el.getBoundingClientRect();
    var cs = window.getComputedStyle(el);
    return r.width > 0 && r.height > 0 && cs.visibility !== 'hidden' && cs.display !== 'none';
  }
  function checkDialogs() {
    document.querySelectorAll('[role="dialog"][aria-modal="true"]').forEach(function (dlg) {
      var label = dlg.getAttribute('aria-label') || '';
      if (/popup form|^form$|^modal$/i.test(label.trim())) {
        var heading = dlg.querySelector('h1, h2, h3, [role="heading"]');
        var text = heading ? heading.textContent.replace(/\s+/g, ' ').trim() : '';
        if (!text) {
          var p = Array.prototype.find.call(dlg.querySelectorAll('p, span, div'), function (n) {
            return n.children.length === 0 && n.textContent.trim().length > 8;
          });
          text = p ? p.textContent.replace(/\s+/g, ' ').trim() : '';
        }
        dlg.setAttribute('aria-label', text ? text.slice(0, 80) : 'Sign up for Zenimal emails');
      }
      if (isShown(dlg) && openDialogs.indexOf(dlg) === -1) {
        dlg.__a11yReturnTo = lastOutsideFocus;
        openDialogs.push(dlg);
      }
    });
    openDialogs = openDialogs.filter(function (dlg) {
      if (isShown(dlg)) return true;
      var active = document.activeElement;
      var lost = !active || active === document.body || !isShown(active) || dlg.contains(active);
      var back = dlg.__a11yReturnTo;
      if (lost && back && back.isConnected && isShown(back)) {
        try { back.focus(); } catch (e) {}
      }
      return false;
    });
  }

  /* The cart button's name must include what it shows: the item count (2.5.3) */
  function fixCartLabel() {
    document.querySelectorAll('.cart-drawer-opener').forEach(function (el) {
      var bubble = el.querySelector('.cart-count-bubble');
      var digits = bubble ? bubble.textContent.replace(/\D+/g, '') : '';
      var n = parseInt(digits || '0', 10);
      var label = 'Cart, ' + n + (n === 1 ? ' item' : ' items');
      if (el.getAttribute('aria-label') !== label) el.setAttribute('aria-label', label);
    });
  }

  function init() {
    fixVideoFallbackImages();
    addVideoButtons();
    addMotionToggles();
    applyMotion();
    fixScrollableRegions();
    fixCartLabel();
    window.addEventListener('load', function () { fixScrollableRegions(); sweepAnimations(); });
    var t = null;
    window.addEventListener('resize', function () {
      clearTimeout(t);
      t = setTimeout(fixScrollableRegions, 300);
    });
    if ('MutationObserver' in window) {
      var pending = false;
      new MutationObserver(function () {
        if (pending) return;
        pending = true;
        setTimeout(function () {
          pending = false;
          fixVideoFallbackImages();
          addVideoButtons();
          checkDialogs();
          fixCartLabel();
          if (motionPaused) sweepAnimations();
        }, 250);
      }).observe(document.body, { childList: true, subtree: true });
    }
    document.addEventListener('keyup', function (e) { if (e.key === 'Escape') setTimeout(checkDialogs, 50); });
    document.addEventListener('click', function () { setTimeout(checkDialogs, 300); }, true);
    setInterval(function () { if (openDialogs.length) checkDialogs(); }, 1000);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();